var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 8.66683H15.3333V15.3335H8.66659V18.6668H15.3333V25.3335H18.6666V18.6668H25.3333V15.3335H18.6666V8.66683ZM16.9999 0.333496C7.79992 0.333496 0.333252 7.80016 0.333252 17.0002C0.333252 26.2002 7.79992 33.6668 16.9999 33.6668C26.1999 33.6668 33.6666 26.2002 33.6666 17.0002C33.6666 7.80016 26.1999 0.333496 16.9999 0.333496ZM16.9999 30.3335C9.64992 30.3335 3.66659 24.3502 3.66659 17.0002C3.66659 9.65016 9.64992 3.66683 16.9999 3.66683C24.3499 3.66683 30.3333 9.65016 30.3333 17.0002C30.3333 24.3502 24.3499 30.3335 16.9999 30.3335Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableProduct);
export default __webpack_public_path__ + "static/media/TableProduct.74a081fb393a86160312dab7023b775a.svg";
export { ForwardRef as ReactComponent };